export default "__VITE_ASSET__Dl5E0nIi__"